import { Component, Input, OnInit, OnDestroy, signal, computed } from '@angular/core';

export interface CarouselSlide {
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
}

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  standalone: true,
  imports: [],
})
export class CarouselComponent implements OnInit, OnDestroy {
  @Input({ required: true }) slides: CarouselSlide[] = [];
  @Input() autoPlayInterval: number = 5000; // Intervalo em milissegundos

  currentSlide = signal(0);
  carouselInterval: any;

  // Computed para o slide atual
  currentSlideData = computed(() => {
    const index = this.currentSlide();
    return this.slides[index] || null;
  });

  // Computed para verificar se há slides
  hasSlides = computed(() => this.slides.length > 0);

  // Computed para verificar se há mais de um slide
  hasMultipleSlides = computed(() => this.slides.length > 1);

  ngOnInit() {
    if (this.hasSlides()) {
      this.startCarousel();
    }
  }

  ngOnDestroy() {
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
  }

  startCarousel() {
    if (!this.hasMultipleSlides()) return;
    
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
    
    this.carouselInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoPlayInterval);
  }

  nextSlide() {
    const current = this.currentSlide();
    const next = (current + 1) % this.slides.length;
    this.currentSlide.set(next);
  }

  previousSlide() {
    const current = this.currentSlide();
    const previous = (current - 1 + this.slides.length) % this.slides.length;
    this.currentSlide.set(previous);
  }

  goToSlide(index: number) {
    this.currentSlide.set(index);
    // Reinicia o carrossel após mudança manual
    this.startCarousel();
  }
}

